import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	user-select: none;
	margin-top: 10px;

	label,
	span {
		font-family: 'GT Walsheim Pro';
		font-size: 14px;
		cursor: pointer;
	}

	label {
		color: #ffffff80;
	}

	span {
		margin-left: auto;
		color: #ffffffc0;
	}
`;

export { StyledContainer };
